module.exports = __webpack_public_path__ + "static/img/reg_tesn_12v-1.a777244.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/reg_tesn_12v-1.svg
// module id = o777
// module chunks = 0